import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';
import {
  ApiGetSmsDetailHistoryOptions,
  ApiGetSmsSubaccountListHistoryOptions,
  SmsHistory,
  SmsHistoryDetail,
  SmsHistoryDetails,
  SmsHistoryList
} from '@models/reseller/sms-history-detail';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ResellerHistoryService {
  private readonly baseUrl;

  constructor(private http: HttpClient) {
    this.baseUrl = environment.serverBaseUrl;
  }

  getListSmsSentList(
    body: ApiGetSmsSubaccountListHistoryOptions,
    pageNum?,
    pageSize?,
    sortColumn?,
    sortDirection?
  ): Observable<SmsHistoryList> {
    let params = new HttpParams();
    if (pageNum) {
      params = params.append('page', pageNum);
    }
    if (pageSize) {
      params = params.append('size', pageSize);
    }
    if (sortColumn) {
      switch (sortColumn) {
        case 'createTime':
          params = params.append('sortColumn', 'SEND_DATE');

          break;
        case 'dateForSend':
          params = params.append('sortColumn', 'DELIVERY_DATE');

          break;
        default:
          break;
      }
    }
    if (sortDirection) {
      params = params.append('sortDirection', sortDirection);
    }
    return this.http
      .post(this.baseUrl + 'subaccount/history/sent-sms-history', body, {
        params
      })
      .pipe(
        map(data => {
          return SmsHistoryList.deserialize({
            data: (data && (data as any).data ? ((data as any).data as Array<string>) : []).map(data2 => SmsHistory.deserialize(data2)),
            total: (data as any).total
          });
        })
      );
  }

  getSmsSentDetails(body: ApiGetSmsDetailHistoryOptions, pageNum?, pageSize?, sortColumn?, sortDirection?): Observable<SmsHistoryDetails> {
    let params = new HttpParams();
    if (pageNum) {
      params = params.append('page', pageNum);
    }
    if (pageSize) {
      params = params.append('size', pageSize);
    }
    if (sortColumn) {
      switch (sortColumn) {
        case 'createTime':
          params = params.append('sortColumn', 'SEND_DATE');

          break;
        case 'dateForSend':
          params = params.append('sortColumn', 'DELIVERY_DATE');

          break;
        default:
          params = params.append('sortColumn', 'STATUS');
          break;
      }
    }
    if (sortDirection) {
      params = params.append('sortDirection', sortDirection);
    }
    return this.http
      .post(this.baseUrl + 'subaccount/history/sent-sms-details', body, {
        params
      })
      .pipe(
        map(data => {
          return SmsHistoryDetails.deserialize({
            data: (data && (data as any).data ? ((data as any).data as Array<string>) : []).map(data2 =>
              SmsHistoryDetail.deserialize(data2)
            ),
            total: (data as any).total
          });
        })
      );
  }

  exportSendSmsDetail(exportFormat, idMessage, idSubaccount): Observable<any> {
    const body = {
      exportFormat,
      idMessage,
      idSubaccount
    };
    return this.http.post(this.baseUrl + 'subaccount/history/export-sent-sms', body);
  }

  exportSendSmsList(
    exportFormat,
    apiGetSmsSubaccountListHistoryOptions: ApiGetSmsSubaccountListHistoryOptions,
    isAggregateByCampaign
  ): Observable<any> {
    const body = {
      isAggregateByCampaign,
      exportFormat,
      dateFrom: apiGetSmsSubaccountListHistoryOptions.dateFrom,
      dateTo: apiGetSmsSubaccountListHistoryOptions.dateTo,
      idSubaccount: apiGetSmsSubaccountListHistoryOptions.idSubaccount
    };
    return this.http.post(this.baseUrl + 'subaccount/history/export-list-sent-sms', body);
  }
}
